export const SHORT_ENV = {
  development: 'dev',
  production: 'prod',
  test: 'test',
};

export const LOCAL_EXT = '.local';
export const DEFAULT_CONFIG_FILES = ['config.ts', 'config.js'];
